import { call, put, select } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import { updateContractConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import * as Sentry from '@sentry/react'

export const energySuppliersActions = {
  LOAD_ENERGY_SUPPLIERS_V2: 'LOAD_ENERGY_SUPPLIERS_V2',
  LOAD_TELECOM_SUPPLIERS_V2: 'LOAD_TELECOM_SUPPLIERS_V2',
}

export function* loadEnergySuppliers({ contractId, energyType }) {
  const { energySuppliersUrl } = yield select(selectExtraRoutesAuthData)
  const endpoint = `${energySuppliersUrl}?&energy=${energyType}`

  const keyMap = { elec: 'energySuppliersElec', gas: 'energySuppliersGas' }
  const storeKey = keyMap[energyType] || 'energySuppliers'

  try {
    const energySuppliers = yield call(callApi, { endpoint })
    yield put(updateContractConfigData({ id: contractId, data: { [storeKey]: energySuppliers } }))
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('loadEnergySupplierError'), { extra: { error } })
    }
  }
}

export function* loadTelecomSuppliers({ contractId }) {
  const { energySuppliersUrl } = yield select(selectExtraRoutesAuthData)
  const endpoint = `${energySuppliersUrl}?&energy=telecom`

  try {
    const telecomSuppliers = yield call(callApi, { endpoint })
    yield put(updateContractConfigData({ id: contractId, data: { telecomSuppliers } }))
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('loadTelecomSupplierError'), { extra: { error } })
    }
  }
}
